<template>
  <page>
    <v-card>
      <v-flex xs12>
        <message :messages="messages"></message>
      </v-flex>
      <v-card-title>
        <div class="headline">Relationship Listing</div>
        <v-spacer></v-spacer>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="items" :search="search" :rows-per-page-items="itemsPerPage" :pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="headerCell" slot-scope="props">
          <v-tooltip bottom>
            <span slot="activator">
              {{ props.header.text }}
            </span>
            <span>
              {{ props.header.text }}
            </span>
          </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
          <td class="text-xs-left">{{ props.item.relShip }}</td>
          <td class="text-xs-left">{{ props.item.relShipDesc }}</td>
          <td class="text-xs-right">
            <table-action :rowData="props" review @review="doReview(props.item.relShip)" remove @remove="doPromptRemove(props.item)"></table-action>
          </td>
        </template>
      </v-data-table>
    </v-card>
    <v-btn color="primary" dark class="mb-2" @click="doNew">
      New Relationship
      <v-icon right>mdi-plus</v-icon>
    </v-btn>
    <v-dialog v-model="showRelShipDialog" width="800px" lazy persistent v-if="checkAccess(['fireRatingReview'])">
      <v-card>
        <v-card-title>
          <span class="headline">Relationship</span>
        </v-card-title>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs6 v-if="newRelShip">
                <v-text-field :label="labels.relShip" v-model="form.relShip" :error-messages="errors.collect('relShip')"
                  data-vv-name="relShip" :data-vv-as="labels.relShip" v-validate="'required|max:2'"/>
              </v-flex>
              <v-flex xs6 v-else>
                <v-subheader class="queryLabel">{{labels.relShip}}</v-subheader>
                <div class="title">{{form.relShip}}</div>
              </v-flex>
              <v-flex xs6>
                <v-text-field :label="labels.relShipDesc" v-model="form.relShipDesc" :error-messages="errors.collect('relShipDesc')"
                  data-vv-name="relShipDesc" :data-vv-as="labels.relShipDesc" v-validate="'required|max:60'"/>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" flat @click.native="doClose">Cancel</v-btn>
          <v-btn color="primary" flat @click.native="doSave">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete">
      Are you sure you want to delete the selected item?
      <div class="title">{{selectedId.text}}</div>
    </confirm>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
export default {
  data() {
    return {
      headers: [
        { text: 'Relationship', value: 'relShip' },
        { text: 'Description', value: 'relShipDesc' },
        TableConst.tableActionHeader
      ],
      labels: {
        relShip: 'Relationship*',
        relShipDesc: 'Description*'
      },
      newRelShip: false,
      showRelShipDialog: false,
      form: {
        relShip: null,
        relShipDesc: null
      },
      selectedId: {
        id: null,
        text: null
      },
      promptRemove: false
    }
  },
  methods: {
    async doFetch() {
      this.loading = true
      this.selectedId.id = null
      this.selectedId.text = null
      const apiUrl = this.menu.relationships
      if (apiUrl) {
        try {
          const result = await this.$http.get(apiUrl)
          const { data } = result.data
          if (result.data) {
            this.items = []
            data.map(relShip => {
              const convertList = {
                relShip: relShip.relShip,
                relShipDesc: relShip.relShipDesc
              }
              this.items.push(convertList)
            })
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.fullMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API URL')
      }
      this.loading = false
    },
    doNew() {
      this.showRelShipDialog = this.newRelShip = true
      this.form.relShip = this.form.relShipDesc = null
      this.resetValidator()
      this.resetMessages()
    },
    async doReview(relShip) {
      const apiURI = this.menu.relationship
      this.newRelShip = false
      if (apiURI) {
        const expand = {
          relShip
        }
        const result = await this.$http.get(expandURI(apiURI, expand))
        const { data } = result.data
        if (result.data) {
          this.form.relShip = data.relationship.relShip
          this.form.relShipDesc = data.relationship.relShipDesc
          this.showRelShipDialog = true
        }
      }
    },
    doSave() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.newRelShip) {
            this.doCreate()
          } else {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.createRelationship
      if (apiURI) {
        try {
          const result = await this.$http.post(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doFetch()
            this.doClose()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.updateRelationship
      if (apiURI) {
        try {
          const result = await this.$http.put(apiURI, this.form)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doFetch()
            this.doClose()
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemove(relShip) {
      this.resetMessages()
      this.selectedId.id = relShip.relShip
      this.selectedId.text = relShip.relShip + ' - ' + relShip.relShipDesc
      this.promptRemove = true
    },
    doDelete() {
      const apiURI = this.menu.deleteRelationship
      if (apiURI) {
        const expand = {
          relShip: this.selectedId.id
        }
        this.$http.delete(expandURI(apiURI, expand)).then(result => {
          const data = result.data
          this.notify(data)
          this.doFetch()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    },
    doClose() {
      this.showRelShipDialog = this.newRelShip = false
      this.form.relShip = this.form.relShipDesc = null
      this.resetValidator()
      this.resetMessages()
    }
  },
  mounted() {
    this.doFetch()
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    menu() {
      return this.$store.state.pa.menu
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
